/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { toggleOverlayByKey } from 'Store/Overlay/Overlay.action';
import { showPopup } from 'Store/Popup/Popup.action';

import StyleGuideComponent from './StyleGuide.component';

/** @namespace Scandipwa/Route/StyleGuide/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    toggleOverlayByKey: (key) => dispatch(toggleOverlayByKey(key)),
    showPopup: (payload) => dispatch(showPopup('title', payload))
});

/** @namespace Scandipwa/Route/StyleGuide/Container */
export class StyleGuideContainer extends PureComponent {
    static propTypes = {
        toggleOverlayByKey: PropTypes.func.isRequired,
        showPopup: PropTypes.func.isRequired
    };

    render() {
        return (
            <StyleGuideComponent
              { ...this.props }
            />
        );
    }
}

// eslint-disable-next-line @scandipwa/scandipwa-guidelines/always-both-mappings
export default connect(null, mapDispatchToProps)(StyleGuideContainer);
